import React from "react";
import { Modal } from "react-bootstrap";
import InfoImg from "../../../../assets/images/info-img.png";

const InfoTaskMarkComplete = ({
    showModal,
    setInfoConfirmModal,
    message,
    msgTranslate,
    getLangTranslation,
    handleInfoTaskMarkSave
}) => {
    // const [isRadioChecked, setIsRadioChecked] = useState(0);

    // const handleClick = (checked) => {
    //     setIsRadioChecked(checked);
    // };

    return (
        <Modal show={showModal} size="sm" className="custom-modal blur-bg" centered>
            <Modal.Header>
                <div className="border-0 pb-0 d-flex justify-content-between w-100">
                    {/* <h6 className="modal-title text-blue-900">Delete selected</h6> */}
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setInfoConfirmModal(false)}
                    ></button>
                </div>
            </Modal.Header>
            <Modal.Body className="py-3 px-4">
                <>
                    <div className="modal-body text-center p-0">
                        {/* <div className="text-center"> */}
                        <div className="my-3">
                            <i className='icon-info-one text-blue-800 display-4 faded-border d-inline-block rounded-circle mb-6' />
                            <h5 className='fw-bold mb-2 text-center'>{getLangTranslation(message, msgTranslate)}</h5>
                        </div>
                        {/* {
                                message[1] && (
                                    <span>{message[1]}</span>
                                )
                            } */}
                        <div className="grid gap-3 my-4">
                            <button
                                className="btn btn-outline-primary g-col-6"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setInfoConfirmModal(false)}
                            >
                                <span className="btn-upper-case">{getLangTranslation("CANCEL", "Cancel")}</span>
                            </button>
                            <button className="btn btn-primary g-col-6" onClick={handleInfoTaskMarkSave}>
                                <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
                            </button>
                        </div>
                    </div>
                    {/* </div> */}
                </>
            </Modal.Body>
        </Modal>
    );
};

export default InfoTaskMarkComplete;
